import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import { Minus, Plus } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductAttributes, selectAllProductAttributes } from "../../../slices/company/productAttributeSlice";
import { fetchTaxes } from "../../../slices/company/taxSlices";
import { API_URL } from "../../../utils/constant";
import axios from "axios";
import { fetchBrands } from "../../../slices/company/brandSlice";
import { fetchUnits } from "../../../slices/company/unitsSlice";
import Select from "react-select";

const AddPurchases = ({ show, onClose, heading, initialData = [], onSubmit, categories = [], suppliers = [] }) => {
    const dispatch = useDispatch();
    const attributes = useSelector(selectAllProductAttributes);
    const { taxes } = useSelector(state => state.accountingTaxes);
    const { brands } = useSelector((state) => state.brands);
    const [variantOptions, setVariantOptions] = useState([]);
    const [selectedTax, setSelectedTax] = useState(null);
    const [accounts, setAccounts] = useState([]);
    const { units } = useSelector(state => state.accountingUnits);
    const [locations, setLocations] = useState([]);

    console.log('indslda', initialData);

    const [locationPrices, setLocationPrices] = useState({});

    const [step, setStep] = useState(1);

    const nextStep = () => setStep((prev) => prev + 1);
    const prevStep = () => setStep((prev) => prev - 1);

    const fetchLocations = async () => {
        try {
            const company_id = localStorage.getItem("companyID");
            const res = await axios.get(
                `${API_URL}/company-locations/${company_id}`
            );
            setLocations(res.data.data || []);
        } catch (err) {
            console.error(err);
        }
    };


    useEffect(() => {
        const company = JSON.parse(localStorage.getItem("company"));
        if (company) {
            const companyId = company.company?.id;
            dispatch(fetchBrands(companyId));
            dispatch(fetchProductAttributes(companyId));
            dispatch(fetchTaxes(companyId));
            dispatch(fetchUnits(companyId));
        }
    }, [dispatch]);

    const [formData, setFormData] = useState({
        purchase_type: 'both',
        product_value_type: '',
        accounting_account: '',
        name: '',
        slug: '',
        sku: '',
        product_image: '',
        category: '',
        low_stock_alert: '',
        tax_included: '',
        is_gst: '',
        is_final_product: false,
        hsn_code: '',
        taxId: '',
        product_type: 'simple', // Default to simple product
        variants: "",
        location_id: [],
        location_prices: [],
        quantity: "",
        sale_type: [],
        final_selling_price: '',
        unit: '',
        is_mrp: 0,
        mrp_price: '',
        mpn: '',
        ean: '',
        isbn: '',
        product_usage_type: '',
        expiry_date: '',
        barcode_required: 0,
        print_label_fields: [],
        is_drug: 0,
        is_rx_required: 0,
    });


    const fetchAccounts = async () => {
        try {

            const company_id = localStorage.getItem("companyID");
            const res = await axios.get(
                `${API_URL}/accounting/accounting?company_id=${company_id}`
            );
            setAccounts(res.data.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchLocations();
        fetchAccounts();
    }, []);

    useEffect(() => {
        if (initialData && initialData.name) {
            setFormData({
                purchase_type: initialData.purchase_type || 'both',
                product_value_type: initialData.product_value_type || '',
                accounting_account: initialData.accounting_account || '',
                brand: initialData.brand || '',
                name: initialData.name || '',
                slug: initialData.slug || '',
                sku: initialData.sku || '',
                short_code: initialData.short_code || '',
                product_image: initialData.product_image || '',
                category: initialData.category || initialData.final_category || '',
                low_stock_alert: initialData.low_stock_alert || '',
                tax_included: initialData.tax_included || '',
                is_gst: initialData.is_gst || '',
                is_final_product: initialData.is_final_product || false,
                hsn_code: (initialData.hsn_code  || initialData.taxes?.hsn_code) ||'',
                taxId: initialData.taxes?.id || '',
                product_type: initialData.product_type || 'simple',
                variants: initialData.variants || "",
                location_id: initialData.location_id || [],
                location_prices: initialData.location_prices || {},
                sale_type: initialData.sale_type || [],
                final_selling_price: initialData.final_selling_price || '',
                quantity: initialData.quantity,
                unit: initialData.unit || initialData.unit || '',
                is_mrp: initialData.is_mrp || 0,
                mrp_price: initialData.mrp_price || '',
                mpn: initialData.mpn || '',
                ean: initialData.ean || '',
                isbn: initialData.isbn || '',
                product_usage_type: initialData.product_usage_type || '',
                expiry_date: initialData.expiry_date || '',
                barcode_required: initialData.barcode_required || 0,
                print_label_fields: initialData.print_label_fields || [],
                is_drug: initialData.is_drug || 0,
                is_rx_required: initialData.is_rx_required || 0,
            });

            setSelectedTax(initialData.taxes?.id || null);

            const parsedVariants = Array.isArray(initialData.variants)
                ? initialData.variants.map(variant => ({
                    attributeId: String(variant.attributeId),
                    selectedTags: Array.isArray(variant.selectedTags)
                        ? variant.selectedTags
                        : [],
                }))
                : [];

            // console.log("Parsed Variants:", parsedVariants);

            setVariantOptions(parsedVariants);
        }
    }, [initialData, categories]);// Removed 'taxes' from dependency array

    // Separate useEffect for taxes-related logic
    useEffect(() => {
        if (initialData && initialData.name && taxes.length > 0) {
            setSelectedTax(
                taxes.find(tax => (tax.hsn_code === (initialData.hsn_code || initialData.hsn_sac))) || null
            );
        } else {
            setSelectedTax(null);
        }
    }, [initialData, taxes]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        console.log(name, value, type);
        setFormData((prevFormData) => {
            const updatedFormData = { ...prevFormData };
            if (type == 'checkbox') {
                updatedFormData[name] = checked ? 1 : 0;
            } else if (type == 'file') {
                updatedFormData[name] = files[0];
            } else {
                updatedFormData[name] = value;
            }
            if (name === 'name') {
                const slug = value
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, '-')
                    .replace(/^-+|-+$/g, '');
                updatedFormData.slug = slug;
            }
            return updatedFormData;
        });
    };

    // NEW: Handle HSN dropdown change
    const handleHSNChange = (e) => {
        const selectedHsn = e.target.value;
        const tax = taxes.find(t => t.hsn_code === selectedHsn);
        setSelectedTax(tax || null);
        setFormData(prev => ({
            ...prev,
            hsn_code: selectedHsn,
            taxId: tax ? tax.id : '',
        }));
    };

    // Handle input changes
    const handleDynamicChange = (e, index, field) => {
        const { value } = e.target;
        const updatedSuppliers = formData.suppliers.map((supplier, idx) =>
            idx === index ? { ...supplier, [field]: value } : supplier
        );
        setFormData({ ...formData, suppliers: updatedSuppliers });
    };

    // Handle adding a new supplier row
    const handleAddRow = () => {
        setFormData({
            ...formData,
            suppliers: [...formData.suppliers, { name: '', cost: '', quantity: '' }] // Add a new empty row
        });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        const formPayload = new FormData();

        const company = JSON.parse(localStorage.getItem('company'));
        // Loop through the formData and append the fields to formPayload
        for (let key in formData) {
            if (formData.hasOwnProperty(key) && key !== 'location_prices') {
                // If key is suppliers, handle it separately as it's an array
                formPayload.append(key, formData[key]);
            }
        }
        if (company) {
            formPayload.append('company_id', company?.company?.id);
        }
        formPayload.append('variants', JSON.stringify(variantOptions));
        formPayload.append("location_prices", JSON.stringify(formData.location_prices));
        console.log('from paulooa ', JSON.stringify(formPayload));
        setFormData({
            name: '',
            slug: '',
            sku: '',
            product_image: '',
            category: '',
            low_stock_alert: '',
            tax_included: '',
            is_gst: '',
            hsn_code: '',
            variants: '',
            location_id: [],
            sale_type: [],
            location_prices: {},
            final_selling_price: '',
        });
        setSelectedTax(null);
        onSubmit(formPayload);
    };

    const handleAddOption = () => {
        setVariantOptions([...(variantOptions || []), { attributeId: '', selectedTags: [] }]);
        // setVariantOptions([...variantOptions, { attributeId: '', selectedTags: [] }]);
    };


    const handleRemoveOption = (index) => {
        const updatedOptions = [...variantOptions];
        updatedOptions.splice(index, 1);
        setVariantOptions(updatedOptions);
    };

    const handleVariantChange = (index, field, value) => {
        const updatedOptions = [...variantOptions];
        updatedOptions[index][field] = value;
        // Reset selected tags if attribute changes
        if (field === 'attributeId') {
            updatedOptions[index].selectedTags = [];
        }
        setVariantOptions(updatedOptions);
    };

    const handleTagToggle = (index, tag) => {
        const updated = [...variantOptions];
        const tags = updated[index].selectedTags;
        updated[index].selectedTags = tags.includes(tag)
            ? tags.filter((t) => t !== tag)
            : [...tags, tag];
        setVariantOptions(updated);
    };

    // Handle location change for react-select
    const handleLocationChange = (selectedOptions) => {
        const selectedValues = selectedOptions
            ? selectedOptions.map(option => option.value)
            : [];

        setFormData(prev => {
            // Remove prices of unselected locations
            const updatedPrices = {};

            selectedValues.forEach(id => {
                updatedPrices[id] = prev.location_prices?.[id] || '';
            });

            return {
                ...prev,
                location_id: selectedValues,
                location_prices: updatedPrices
            };
        });
    };

    const handlePriceChange = (locationId, value) => {
        setFormData(prev => ({
            ...prev,
            location_prices: {
                ...prev.location_prices,
                [locationId]: value
            }
        }));
    };
    // Prepare location options for react-select
    const locationOptions = locations.map(location => ({
        value: location.id,
        label: location.name
    }));

    // Get selected location options for react-select value
    const selectedLocationOptions = locationOptions.filter(option =>
        formData.location_id && formData.location_id.includes(option.value)
    );


    const saleTypeOptions = [
        { value: 'offline', label: 'Offline Sales' },
        { value: 'online', label: 'Online Product or Service' },
        { value: 'both', label: 'Available for Both Online and Offline' },
        { value: 'delivery', label: 'Delivery by Store' }
    ];


    const handleSaleTypeChange = (selectedOptions) => {
        const selectedValues = selectedOptions
            ? selectedOptions.map(option => option.value)
            : [];

        setFormData(prev => ({
            ...prev,
            sale_type: selectedValues
        }));
    };

    const printLabelOptions = [
        { value: 'name', label: 'Name' },
        { value: 'hsn', label: 'HSN/SAC' },
        { value: 'short_code', label: 'Short Code' },
        { value: 'sku', label: 'SKU' },
        { value: 'serial', label: 'Serial Number' },
        { value: 'category', label: 'Category' },
        { value: 'brand', label: 'Brand' },
        { value: 'price', label: 'Price' },
        { value: 'variant', label: 'Variant Code' },
        { value: 'mpn', label: 'MPN' },
        { value: 'ean', label: 'EAN' },
        { value: 'isbn', label: 'ISBN' },
        { value: 'expiry', label: 'Expiry' }
    ];

    const handlePrintLabelChange = (selected) => {
        if (selected && selected.length > 4) return;

        setFormData(prev => ({
            ...prev,
            print_label_fields: selected ? selected.map(s => s.value) : []
        }));
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
            size="xl"
        >
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="row">

                    {/* LEFT SIDE STEPS */}
                    <div className="col-md-3 border-end">
                        <ul className="list-group step-list">
                            <li onClick={() => setStep(1)} className={`list-group-item fs-18 ${step === 1 ? 'active bg-primary' : ''}`}>Basic Details</li>
                            <li onClick={() => setStep(2)} className={`list-group-item fs-18 ${step === 2 ? 'active bg-primary' : ''}`}>Product Details</li>
                            <li onClick={() => setStep(3)} className={`list-group-item fs-18 ${step === 3 ? 'active bg-primary' : ''}`}>Variants</li>
                            <li onClick={() => setStep(4)} className={`list-group-item fs-18 ${step === 4 ? 'active bg-primary' : ''}`}>Pricing</li>
                            <li onClick={() => setStep(5)} className={`list-group-item fs-18 ${step === 5 ? 'active bg-primary' : ''}`}>Other Settings</li>
                        </ul>
                    </div>
                    <div className="col-md-9">
                        {step === 1 && (
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Purchase Type</label>
                                        <select name="purchase_type" value={formData.purchase_type} className="form-control" onChange={handleChange}>
                                            <option value="">Select Purchase Type</option>
                                            <option value="purchase">Purchase Item</option>
                                            <option value="final">Final Selling Item</option>
                                            <option value="both">Both</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Product Value</label>
                                        <select name="product_value_type" value={formData.product_value_type} className="form-control" onChange={handleChange}>
                                            <option value="">Select Product Type</option>
                                            <option value="Sealed">Sealed</option>
                                            <option value="Loose">Loose</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Accounting accout</label>
                                        <select name="accounting_account" value={formData.accounting_account} className="form-control" onChange={handleChange}>
                                            <option value="">Select Acccounting Account</option>
                                            {accounts.map(account => (
                                                <option key={account.id} value={account.id}>
                                                    {account.name} ({account.code})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Product Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="Enter Name"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Slug</label>
                                        <input
                                            type="text"
                                            name="slug"
                                            className="form-control"
                                            value={formData.slug}
                                            onChange={handleChange}
                                            placeholder="Enter Slug"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>HSN/SAC</label>
                                        <select
                                            name="hsn_code"
                                            className="form-control"
                                            value={formData.hsn_code}
                                            onChange={handleHSNChange}
                                            required
                                        >
                                            <option value="">Select HSN/SAC</option>
                                            {taxes.map((tax) => (
                                                <option key={tax.id} value={tax.hsn_code}>
                                                    {tax.hsn_code} - {tax.name} - {tax.rate}%
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Short Code</label>
                                        <input
                                            type="text"
                                            name="short_code"
                                            className="form-control"
                                            value={formData.short_code}
                                            onChange={handleChange}
                                            placeholder="Enter Short Code"
                                        />
                                    </div>
                                </div>



                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Product Code / SKU / Article Number / Article Name</label>
                                        <input
                                            type="text"
                                            name="sku"
                                            className="form-control"
                                            value={formData.sku}
                                            onChange={handleChange}
                                            placeholder="Product Code / SKU / Article Number"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {step === 2 && (
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Category</label>
                                        {/* <input
                                type="text"
                                name="category"
                                className="form-control"
                                value={formData.category}
                                onChange={handleChange}
                                placeholder="Enter Category"
                            /> */}
                                        <select
                                            name="category"
                                            className="form-control"
                                            value={formData.category}
                                            onChange={(e) => {
                                                const selectedCategoryId = e.target.value;

                                                // Get the selected category based on its ID
                                                const selectedCategory = categories.find((c) => c.id == selectedCategoryId);

                                                // Update the formData and set the selected category
                                                setFormData({
                                                    ...formData,
                                                    category: selectedCategoryId, // Update category with selected value
                                                    // hsn_code: selectedCategory?.hsn_code || '' // Update HSN code (set empty if no hsn_code found)
                                                });

                                                // Update the selected category state (optional)
                                                // if (selectedCategory) {
                                                //     setSelectedTax(taxes.find(tax => tax.hsn_code === selectedCategory.hsn_code) || null);
                                                // }
                                            }}
                                            required
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map((cat) => (
                                                <option key={cat.id} value={cat.id}>
                                                    {cat.name}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                </div>



                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Brand</label>
                                        <select
                                            name="brand"
                                            className="form-control"
                                            value={formData.brand}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Brand</option>
                                            {brands.map((brand) => (
                                                <option key={brand.id} value={brand.id}>
                                                    {brand.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Unit</label>
                                        <select
                                            name="unit"
                                            className="form-control"
                                            value={formData.unit}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Unit</option>
                                            {units.map((unit) => (
                                                <option key={unit.id} value={unit.id}>
                                                    {unit.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>




                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Product Image</label>
                                        <input
                                            type="file"
                                            name="product_image"
                                            className="form-control"
                                            onChange={handleChange}
                                            placeholder="Select Image"
                                            accept=".png/.jpeg"
                                        />
                                    </div>
                                </div>



                                <div className="col-md-4">
                                    <div className="form-group mb-4">
                                        <label>Tax</label>
                                        <input
                                            type="text"
                                            readOnly
                                            className="form-control"
                                            value={selectedTax ? `${selectedTax.name} - ${selectedTax.rate}%` : ''}
                                            placeholder="Tax"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group mb-4">
                                        <label>Low Stock Alert</label>
                                        <input
                                            type="number"
                                            name="low_stock_alert"
                                            className="form-control"
                                            value={formData.low_stock_alert}
                                            onChange={handleChange}
                                            placeholder="Enter Low Stock Alert Value"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {step === 3 && (
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group mb-4">
                                        <label>Product Type</label>
                                        <select
                                            name="product_type"
                                            className="form-control"
                                            value={formData.product_type}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="simple">Simple Product</option>
                                            <option value="variable">Variants Product</option>
                                        </select>
                                    </div>
                                </div>
                                {(formData.product_type === 'variants' || formData.product_type == 'variable') ? (
                                    <div className="col-12 mb-4">
                                        <h6 className="mb-2">Product Variants</h6>

                                        {variantOptions && variantOptions.map((option, index) => {
                                            const selectedAttribute = attributes.find(attr => attr.id == option.attributeId);
                                            return (
                                                <div key={index} className="mb-3 border rounded p-3">
                                                    <div className="row align-items-center">
                                                        <div className="col-md-4">
                                                            <label>Attribute</label>
                                                            <select
                                                                className="form-control"
                                                                value={option.attributeId}
                                                                onChange={(e) => handleVariantChange(index, 'attributeId', e.target.value)}
                                                            >
                                                                <option value="">Select Attribute</option>
                                                                {attributes.map(attr => {
                                                                    const isAlreadySelected = variantOptions.some(
                                                                        (opt, i) => opt.attributeId == attr.id && i !== index
                                                                    );
                                                                    return (
                                                                        <option
                                                                            key={attr.id}
                                                                            value={attr.id}
                                                                            disabled={isAlreadySelected}
                                                                        >
                                                                            {attr.name} {isAlreadySelected ? "(Selected)" : ""}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>

                                                        </div>

                                                        {selectedAttribute && (
                                                            <div className="col-md-7 mt-3 mt-md-0">
                                                                <label>Tags</label>
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    {selectedAttribute.tags.map(tag => (
                                                                        <div key={tag} className="form-check me-3">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                checked={option.selectedTags.includes(tag)}
                                                                                onChange={() => handleTagToggle(index, tag)}
                                                                                id={`tag-${index}-${tag}`}
                                                                            />
                                                                            <label className="form-check-label ms-1" htmlFor={`tag-${index}-${tag}`}>{tag}</label>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="col-md-1 d-flex align-items-start justify-content-end">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-danger mt-4"
                                                                onClick={() => handleRemoveOption(index)}
                                                                title="Remove Attribute Option"
                                                            >
                                                                ❌
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}

                                        <button type="button" className="btn btn-outline-primary" onClick={handleAddOption}>
                                            <Plus size={16} className="me-1" /> Add Option
                                        </button>
                                    </div>
                                ): (
                                    !initialData && (<div className="col-md-3">
                                        <label>Quantity</label>
                                        <input
                                            type="number"
                                            name="quantity"
                                            className="form-control"
                                            value={formData.quantity}
                                            onChange={handleChange}
                                            placeholder="Enter Quantity"
                                        />
                                    </div>)
                                )}
                                
                            </div>
                        )}

                        {step === 4 && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group mb-4">
                                        <label>Locations</label>
                                        <Select
                                            isMulti
                                            name="location_id"
                                            options={locationOptions}
                                            value={selectedLocationOptions}
                                            onChange={handleLocationChange}
                                            placeholder="Select Locations"
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            closeMenuOnSelect={false}
                                            isClearable={true}
                                            isSearchable={true}
                                        />
                                    </div>
                                </div>

                                {Array.isArray(formData.location_id) && formData.location_id.map((locId) => {
                                    const location = locationOptions.find(opt => opt.value === locId);

                                    return (
                                        <div className="row mb-3" key={locId}>
                                            <div className="col-md-3">
                                                <label>{location?.label}</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder={`Enter Sale Price for ${location?.label}`}
                                                    value={formData.location_prices?.[locId] || ''}
                                                    onChange={(e) =>
                                                        handlePriceChange(locId, e.target.value)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    );
                                })}

                                <div className="col-md-12">
                                    <div className="form-group mb-4">
                                        <label>Sale Type</label>
                                        <Select
                                            isMulti
                                            name="sale_type"
                                            options={saleTypeOptions}
                                            value={saleTypeOptions.filter(option =>
                                                (formData.sale_type || []).includes(option.value)
                                            )}
                                            onChange={handleSaleTypeChange}
                                            placeholder="Select Sale Type"
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            closeMenuOnSelect={false}
                                            isClearable={true}
                                            isSearchable={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group mb-4">
                                        <label>Final Selling Price</label>

                                        <div className="input-group">
                                            <span className="input-group-text">₹</span>

                                            <input
                                                type="number"
                                                name="final_selling_price"
                                                className="form-control"
                                                value={formData.final_selling_price}
                                                onChange={handleChange}
                                                placeholder="Enter Selling Price"
                                            />

                                            <span className="input-group-text">
                                                {units.find(u => u.id == formData.unit)?.name || 'Unit'}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-8">
                                    <div className="form-group mb-4">
                                        <label>MRP</label>

                                        <div className="input-group">

                                            {/* Checkbox inside input group */}
                                            <div className="input-group-text">
                                                <input
                                                    type="checkbox"
                                                    name="is_mrp"
                                                    className="form-check-input mt-0"
                                                    checked={formData.is_mrp}
                                                    onChange={handleChange}
                                                />
                                                <span className="ms-2">MRP</span>
                                            </div>

                                            {/* MRP Input */}
                                            <span className="input-group-text">₹</span>

                                            <input
                                                type="number"
                                                name="mrp_price"
                                                className="form-control"
                                                value={formData.mrp_price}
                                                onChange={handleChange}
                                                placeholder="Enter MRP Price"
                                                disabled={!formData.is_mrp}
                                            />

                                            {/* Unit display (optional) */}
                                            <span className="input-group-text">
                                                {units.find(u => u.id == formData.unit)?.name || 'Unit'}
                                            </span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {step === 5 && (
                            <div className="row">
                                

                                <div className="col-md-4">
                                    <div className="form-group mb-4">
                                        <label>Manufacture Part Number (MPN)</label>
                                        <input
                                            type="text"
                                            name="mpn"
                                            className="form-control"
                                            value={formData.mpn}
                                            onChange={handleChange}
                                            placeholder="Enter MPN"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group mb-4">
                                        <label>EAN</label>
                                        <input
                                            type="text"
                                            name="ean"
                                            className="form-control"
                                            value={formData.ean}
                                            onChange={handleChange}
                                            placeholder="Enter EAN"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group mb-4">
                                        <label>ISBN</label>
                                        <input
                                            type="text"
                                            name="isbn"
                                            className="form-control"
                                            value={formData.isbn}
                                            onChange={handleChange}
                                            placeholder="Enter ISBN"
                                        />
                                    </div>
                                </div>


                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <label>Product Usage Type</label>
                                        <select
                                            name="product_usage_type"
                                            className="form-control"
                                            value={formData.product_usage_type}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="none">No Expiry</option>
                                            <option value="expiry">Has Expiry Date</option>
                                            <option value="single">Single Use Product</option>
                                        </select>
                                    </div>
                                </div>

                                {formData.product_usage_type === 'expiry' && (
                                    <div className="col-md-6">
                                        <div className="form-group mb-4">
                                            <label>Expiry Date</label>
                                            <input
                                                type="date"
                                                name="expiry_date"
                                                className="form-control"
                                                value={formData.expiry_date}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                )}



                                <div className="col-md-12">
                                    <div className="form-group mb-4">
                                        <label>Print Label Fields (Max 4)</label>
                                        <Select
                                            isMulti
                                            options={printLabelOptions}
                                            value={printLabelOptions.filter(option =>
                                                (formData.print_label_fields || []).includes(option.value)
                                            )}
                                            onChange={handlePrintLabelChange}
                                            placeholder="Select up to 4 fields"
                                        />
                                    </div>
                                </div>


                                <div className="col-md-6">
                                    <div className="form-group mb-4">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                name="is_drug"
                                                className="form-check-input"
                                                checked={formData.is_drug}
                                                onChange={handleChange}
                                                id="isDrug"
                                            />
                                            <label className="form-check-label ms-2" htmlFor="isDrug">
                                                Is this a Drug?
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {formData.is_drug == 1 && (
                                    <div className="col-md-6">
                                        <div className="form-group mb-4">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    name="is_rx_required"
                                                    className="form-check-input"
                                                    checked={formData.is_rx_required}
                                                    onChange={handleChange}
                                                    id="isRx"
                                                />
                                                <label className="form-check-label ms-2" htmlFor="isRx">
                                                    Rx Product (Prescription Required)
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}


                                <div className="col-md-6">
                                    <div className="form-check mb-4">
                                        <input
                                            type="checkbox"
                                            name="barcode_required"
                                            className="form-check-input"
                                            checked={formData.barcode_required}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label ms-2">Barcode Required</label>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-check mb-4">
                                        <input
                                            type="checkbox"
                                            name="tax_included"
                                            className="form-check-input"
                                            checked={formData.tax_included}
                                            onChange={handleChange}
                                            placeholder="Enter Tax Included"
                                        />
                                        <label className="form-check-label ms-2">Tax Included</label>

                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-check mb-4">
                                        <input
                                            type="checkbox"
                                            name="is_gst"
                                            className="form-check-input"
                                            checked={formData.is_gst}
                                            onChange={handleChange}
                                            placeholder="Enter Gst Included"
                                        />
                                        <label className="form-check-label ms-2">Is GST</label>

                                    </div>
                                </div>
                            </div>
                        )}


                        <div className="d-flex justify-content-end mt-4">

                            {step > 1 && (
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={prevStep}>
                                    Previous
                                </button>
                            )}
                            <button
                                type="button"
                                className="btn btn-dark me-2 ms-2"
                                onClick={onClose}
                            >
                                Cancel
                            </button>

                            {step < 5 && (
                                <button
                                    type="button"
                                    className="btn btn-primary ms-auto"
                                    onClick={nextStep}>
                                    Next
                                </button>
                            )}

                           
                            {step === 5 && (
                                <>
                                    
                                    <button type="submit" className="btn btn-primary">
                                        Save
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>



            </form>
        </Modal>
    );
};

export default AddPurchases;
